import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #00a859;
  height: 56px;
  border-radius: 10px;
  border: 0;
  padding: 0 16px;
  color: #fff;
  width: 100%;
  font-weight: 600;
  margin-top: 16px;
  transition: background-color 0.2s;

  &:hover {
    /* Shade in this case will darken the color in 20% (0.2) */
    background: ${shade(0.2, '#00A859')};
  }
`;
